'use strict';

var isEdge = require('./is-edge');
var isSamsung = require('./is-samsung');

module.exports = function isChrome(ua) {
  ua = ua || navigator.userAgent;
  return (ua.indexOf('Chrome') !== -1 || ua.indexOf('CriOS') !== -1) && !isEdge(ua) && !isSamsung(ua);
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-chrome.js
// module id = 637
// module chunks = 0